import { useState } from 'react';
import GlassCard from '@/components/base/GlassCard';
import { notifications, messages } from '@/mocks/phase2Data';

const notifIcons: Record<string, { icon: string; color: string }> = {
  basvuru: { icon: 'ri-user-add-line', color: '#ff4d4d' },
  randevu: { icon: 'ri-calendar-check-line', color: '#10b981' },
  puan: { icon: 'ri-star-line', color: '#ff8c42' },
  iptal: { icon: 'ri-close-circle-line', color: '#ef4444' },
  sistem: { icon: 'ri-settings-3-line', color: '#6b7280' },
};

const MessagesPage: React.FC = () => {
  const [localNotifs, setLocalNotifs] = useState(notifications);
  const [activeMsg, setActiveMsg] = useState(messages[0]);
  const [replyText, setReplyText] = useState('');
  const [bulkText, setBulkText] = useState('');
  const [bulkSent, setBulkSent] = useState(false);
  const [activeTab, setActiveTab] = useState<'mesajlar' | 'bildirimler' | 'toplu'>('mesajlar');

  const unreadNotifs = localNotifs.filter((n) => !n.okundu).length;
  const unreadMsgs = messages.filter((m) => !m.okundu).length;

  const markAllRead = () => setLocalNotifs((prev) => prev.map((n) => ({ ...n, okundu: true })));

  const handleBulkSend = () => {
    if (bulkText.trim()) {
      setBulkSent(true);
      setBulkText('');
      setTimeout(() => setBulkSent(false), 3000);
    }
  };

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Inter, sans-serif' }}>Mesaj & Bildirim</h1>
        <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>İletişim merkezi ve bildirim yönetimi</p>
      </div>

      {/* Summary cards */}
      <div className="grid grid-cols-3 gap-3 mb-5">
        {[
          { label: 'Okunmamış Mesaj', value: unreadMsgs, icon: 'ri-message-3-line', color: '#ff4d4d' },
          { label: 'Okunmamış Bildirim', value: unreadNotifs, icon: 'ri-notification-3-line', color: '#ff8c42' },
          { label: 'Toplam İletişim', value: notifications.length + messages.length, icon: 'ri-chat-3-line', color: '#10b981' },
        ].map((c) => (
          <div key={c.label} className="rounded-xl p-4 transition-all duration-300 hover:-translate-y-1" style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${c.color}22` }}>
            <div className="flex items-center justify-between mb-2">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: `${c.color}22` }}>
                <i className={`${c.icon} text-sm`} style={{ color: c.color }}></i>
              </div>
              {c.value > 0 && (
                <span className="text-xs font-bold px-2 py-0.5 rounded-full" style={{ background: `${c.color}22`, color: c.color }}>{c.value}</span>
              )}
            </div>
            <div className="text-xl font-bold text-white" style={{ fontFamily: 'JetBrains Mono, monospace' }}>{c.value}</div>
            <div className="text-xs mt-0.5" style={{ color: '#6b7280' }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 p-1 rounded-xl w-fit" style={{ background: 'rgba(255,255,255,0.04)' }}>
        {[
          { id: 'mesajlar' as const, label: 'Mesajlar', count: unreadMsgs },
          { id: 'bildirimler' as const, label: 'Bildirimler', count: unreadNotifs },
          { id: 'toplu' as const, label: 'Toplu Mesaj', count: 0 },
        ].map((t) => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium cursor-pointer transition-all whitespace-nowrap"
            style={{
              background: activeTab === t.id ? 'linear-gradient(135deg, rgba(255,77,77,0.25), rgba(255,140,66,0.15))' : 'transparent',
              color: activeTab === t.id ? '#ff6b47' : '#6b7280',
              border: activeTab === t.id ? '1px solid rgba(255,77,77,0.3)' : '1px solid transparent',
            }}
          >
            {t.label}
            {t.count > 0 && (
              <span className="text-xs px-1.5 py-0.5 rounded-full font-bold" style={{ background: '#ff4d4d', color: '#fff', fontSize: '10px' }}>{t.count}</span>
            )}
          </button>
        ))}
      </div>

      {/* Messages tab */}
      {activeTab === 'mesajlar' && (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* Message list */}
          <GlassCard title="Gelen Kutusou" className="lg:col-span-1">
            <div className="space-y-1">
              {messages.map((m) => (
                <div
                  key={m.id}
                  onClick={() => setActiveMsg(m)}
                  className="flex items-start gap-2.5 p-2.5 rounded-lg cursor-pointer transition-all"
                  style={{
                    background: activeMsg?.id === m.id ? 'rgba(255,77,77,0.1)' : 'rgba(255,255,255,0.03)',
                    border: activeMsg?.id === m.id ? '1px solid rgba(255,77,77,0.25)' : '1px solid transparent',
                  }}
                >
                  <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ background: m.tip === 'uzman' ? 'linear-gradient(135deg,#ff4d4d,#ff8c42)' : 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}>
                    {m.gonderen[0]}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-medium text-white truncate">{m.gonderen}</span>
                      <span className="text-xs flex-shrink-0 ml-1" style={{ color: '#6b7280', fontSize: '10px' }}>{m.zaman}</span>
                    </div>
                    <p className="text-xs truncate mt-0.5" style={{ color: '#6b7280' }}>{m.mesaj}</p>
                  </div>
                  {!m.okundu && <div className="w-2 h-2 rounded-full flex-shrink-0 mt-1" style={{ background: '#ff4d4d' }} />}
                </div>
              ))}
            </div>
          </GlassCard>

          {/* Message detail */}
          <GlassCard className="lg:col-span-2" title={activeMsg ? `${activeMsg.gonderen} ile Konuşma` : 'Mesaj Seç'}>
            {activeMsg ? (
              <div className="flex flex-col gap-3">
                <div className="flex items-start gap-3 p-3 rounded-xl" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <div className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0" style={{ background: activeMsg.tip === 'uzman' ? 'linear-gradient(135deg,#ff4d4d,#ff8c42)' : 'linear-gradient(135deg,#6366f1,#8b5cf6)' }}>
                    {activeMsg.gonderen[0]}
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-sm font-medium text-white">{activeMsg.gonderen}</span>
                      <span className="text-xs px-1.5 py-0.5 rounded-full" style={{ background: activeMsg.tip === 'uzman' ? 'rgba(255,77,77,0.15)' : 'rgba(99,102,241,0.15)', color: activeMsg.tip === 'uzman' ? '#ff6b47' : '#818cf8', fontSize: '10px' }}>
                        {activeMsg.tip === 'uzman' ? 'Uzman' : 'Müşteri'}
                      </span>
                    </div>
                    <p className="text-sm" style={{ color: '#d1d5db' }}>{activeMsg.mesaj}</p>
                    <p className="text-xs mt-1" style={{ color: '#6b7280' }}>{activeMsg.zaman}</p>
                  </div>
                </div>
                {/* Reply */}
                <div className="flex gap-2 mt-1">
                  <input
                    type="text"
                    value={replyText}
                    onChange={(e) => setReplyText(e.target.value)}
                    placeholder="Yanıtınızı yazın..."
                    className="flex-1 px-3 py-2 rounded-lg text-sm text-white outline-none"
                    style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' }}
                    onKeyDown={(e) => { if (e.key === 'Enter') setReplyText(''); }}
                  />
                  <button
                    onClick={() => setReplyText('')}
                    className="px-3 py-2 rounded-lg text-sm font-medium cursor-pointer transition-all hover:opacity-90 whitespace-nowrap"
                    style={{ background: 'linear-gradient(135deg, #ff4d4d, #ff8c42)', color: '#fff' }}
                  >
                    <i className="ri-send-plane-line"></i>
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center h-32 text-gray-500">
                <span className="text-sm">Sol taraftan mesaj seçin</span>
              </div>
            )}
          </GlassCard>
        </div>
      )}

      {/* Notifications tab */}
      {activeTab === 'bildirimler' && (
        <GlassCard
          title="Bildirimler"
          headerRight={
            <button onClick={markAllRead} className="text-xs cursor-pointer transition-all hover:opacity-80 whitespace-nowrap px-3 py-1 rounded-lg" style={{ background: 'rgba(255,77,77,0.15)', color: '#ff6b47' }}>
              Tümünü Okundu İşaretle
            </button>
          }
        >
          <div className="space-y-2">
            {localNotifs.map((n) => (
              <div
                key={n.id}
                className="flex items-start gap-3 p-3 rounded-xl transition-all duration-200"
                style={{ background: n.okundu ? 'rgba(255,255,255,0.02)' : 'rgba(255,77,77,0.06)', border: n.okundu ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(255,77,77,0.15)' }}
              >
                <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: `${notifIcons[n.tip]?.color}22` }}>
                  <i className={`${notifIcons[n.tip]?.icon} text-sm`} style={{ color: notifIcons[n.tip]?.color }}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm" style={{ color: n.okundu ? '#9ca3af' : '#e5e7eb' }}>{n.mesaj}</p>
                  <p className="text-xs mt-0.5" style={{ color: '#6b7280' }}>{n.zaman}</p>
                </div>
                {!n.okundu && <div className="w-2 h-2 rounded-full flex-shrink-0 mt-1.5" style={{ background: '#ff4d4d' }} />}
              </div>
            ))}
          </div>
        </GlassCard>
      )}

      {/* Bulk message tab */}
      {activeTab === 'toplu' && (
        <GlassCard title="Toplu Mesaj Gönder" subtitle="Tüm uzmanlar veya müşterilere mesaj gönderin">
          <div className="space-y-4 max-w-2xl">
            <div>
              <label className="text-xs font-medium mb-1.5 block" style={{ color: '#9ca3af' }}>Alıcı Grubu</label>
              <div className="flex gap-2">
                {['Tüm Uzmanlar', 'Aktif Uzmanlar', 'Bekleyen Başvurular', 'Tüm Müşteriler'].map((g) => (
                  <button key={g} className="px-3 py-1.5 rounded-lg text-xs font-medium cursor-pointer transition-all whitespace-nowrap" style={{ background: 'rgba(255,255,255,0.06)', color: '#d1d5db', border: '1px solid rgba(255,255,255,0.1)' }}>{g}</button>
                ))}
              </div>
            </div>
            <div>
              <label className="text-xs font-medium mb-1.5 block" style={{ color: '#9ca3af' }}>Mesaj İçeriği</label>
              <textarea
                value={bulkText}
                onChange={(e) => setBulkText(e.target.value.slice(0, 500))}
                placeholder="Mesajınızı buraya yazın..."
                rows={5}
                className="w-full px-3 py-2 rounded-xl text-sm text-white outline-none resize-none"
                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', fontSize: '13px' }}
              />
              <div className="text-xs text-right mt-1" style={{ color: '#6b7280' }}>{bulkText.length}/500</div>
            </div>
            {bulkSent && (
              <div className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ background: 'rgba(16,185,129,0.15)', border: '1px solid rgba(16,185,129,0.3)' }}>
                <i className="ri-check-line text-sm" style={{ color: '#10b981' }}></i>
                <span className="text-sm" style={{ color: '#10b981' }}>Mesaj başarıyla gönderildi!</span>
              </div>
            )}
            <button
              onClick={handleBulkSend}
              disabled={!bulkText.trim()}
              className="px-5 py-2.5 rounded-xl text-sm font-semibold cursor-pointer transition-all hover:opacity-90 whitespace-nowrap disabled:opacity-40"
              style={{ background: 'linear-gradient(135deg, #ff4d4d, #ff8c42)', color: '#fff' }}
            >
              <i className="ri-send-plane-2-line mr-2"></i>Toplu Gönder
            </button>
          </div>
        </GlassCard>
      )}
    </div>
  );
};

export default MessagesPage;
